import { AnyAction, configureStore, ThunkDispatch } from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import createSagaMiddleware from "redux-saga";
import rootReducer from "src/redux/root-reducer";

import rootSaga from "./root-saga";

const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => {
    if (process.env.NODE_ENV === "production") {
      return getDefaultMiddleware({
        serializableCheck: {
          ignoreActions: true,
        },
      }).concat(sagaMiddleware);
    }

    return getDefaultMiddleware({
      serializableCheck: {
        ignoreActions: true,
      },
    }).concat(sagaMiddleware);
  },
  devTools: process.env.NODE_ENV !== "production",
});

sagaMiddleware.run(rootSaga);

if (process.env.NODE_ENV !== "production" && module.hot) {
  module.hot.accept("./root-reducer", () => store.replaceReducer(rootReducer));
}

export type RootState = ReturnType<typeof store.getState>;
// https://github.com/reduxjs/redux-toolkit/issues/485
export type AppDispatch = ThunkDispatch<RootState, null, AnyAction>;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;
